/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ProductCategoryWiseUsage {
    getFixupPrototypeFunction() { return ProductCategoryWiseUsage.fixupPrototype; }

    static newInstance(model: Partial<ProductCategoryWiseUsage>): ProductCategoryWiseUsage {
        let obj = Object.assign(new ProductCategoryWiseUsage(), model);
        ProductCategoryWiseUsage.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ProductCategoryWiseUsage>): ProductCategoryWiseUsage {
        if (!model) return null;
        return ProductCategoryWiseUsage.newInstance(<ProductCategoryWiseUsage> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ProductCategoryWiseUsage) {
        if (!obj) return;

        models.ProductCategoryWiseUsage.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ProductCategoryWiseUsage): boolean {
        Object.setPrototypeOf(obj, ProductCategoryWiseUsage.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.cost === undefined) {
            this.cost = 0;
        }
    }

    /**
     * Product category of the usage
     */
    name: string;

    /**
     * Cost of the resource in the usage
     */
    cost: number;

}
